export default __webpack_public_path__ + "static/media/EM0333.34I-41686_-24973_0.e211304a.jpg";